import { render, staticRenderFns } from "./UploadFileMultiple.vue?vue&type=template&id=2b2f6d60&scoped=true&"
import script from "./UploadFileMultiple.vue?vue&type=script&lang=js&"
export * from "./UploadFileMultiple.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileMultiple.vue?vue&type=style&index=0&id=2b2f6d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f6d60",
  null
  
)

export default component.exports